<div class="page-header">
  <div class="align-items-md-center">
    <div class="row hdrBar">
      <div class="col-lg-4 col-md-4">
        <h1>
          <app-common-header [header_name]="header_label"></app-common-header>
        </h1>
      </div>
      <div class="col-lg-8 col-md-8 mg-a">
        <span class="slctDteLbl">Select District:</span>

        <nz-select
          class="slctBx"
          style="width: 200px; text-align: left"
          nzShowSearch
          [(ngModel)]="slctd_dstrt"
          (ngModelChange)="getDstrwiseData($event)"
          [ngModelOptions]="{ standalone: true }"
          nzPlaceHolder="Select a district"
        >
          @if (slctd_dstrt == 0) {
          <nz-option [nzValue]="0" nzLabel="All"></nz-option>
          } @for (v of dstrtdata; track v) {
          <nz-option [nzValue]="v.tnt_id" [nzLabel]="v.tnt_nm"></nz-option>
          }
        </nz-select>
      </div>
    </div>
  </div>
</div>

<div class="apsfl_dshbrd">
  <div class="row">
    @for (g of assetCardsData; track g; let i = $index) {
    <div class="col-md-3">
      <div
        class="crd_style"
        [ngClass]="g.ast_typ_id == slectdCrd ? 'bg-css' : 'crd_style'"
        (click)="selctedcard(g, i)"
      >
        <div class="row">
          <div class="col-md-8 cstmcol">
            <div class="actvts" [ngStyle]="{ background: g.crd_clr }">
              {{ g.ast_typ_nm }}
              <span style="color: #030303">({{ g.ttl_ast }})</span>
            </div>
          </div>
        </div>
        <div class="row rwpdng">
          <div class="col-md-6">
            <div class="cnt">{{ g.wrkng }}</div>
            <div class="crd_title">
              <span class="cstmfnt" style="color: #f19000">Working</span>
            </div>
          </div>
          <div class="col-md-6">
            <div class="cnt">{{ g.not_wrkng }}</div>
            <div class="crd_title">
              <span class="cstmfnt" style="color: #4caf50"> Not Working</span>
            </div>
          </div>
        </div>
        @if (slectdCrd == g.ast_typ_id) {
        <span
          nz-icon
          nzType="caret-down"
          nzTheme="outline"
          style="position: absolute; left: 50%; font-size: 30px; color: #544795"
        ></span>
        }
      </div>
    </div>
    }
  </div>

  <div class="cstmTb px-4 pt-2 crd_style" style="margin-top: 0px">
    <div class="col-lg-12 col-md-12 mgnb-2 p-8">
      <div class="card_ttl">
        <div class="row">
          <div class="col-md-8">
            <div class="card_hdr_ttl" style="position: relative">
              {{ slectdCrd_nm }}
            </div>
          </div>
        </div>
      </div>
      <app-data-grid
        id="gridContainer"
        class="p-8"
        style="width: 100%"
        [dataSource]="assetGridData"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="false"
        [filterPanel]="false"
        [groupPanel]="slectdCrd == 0"
        [columnChooser]="false"
        [allowExport]="true"
        exportFileName="export"
        [pageSize]="25"
        [allowedPageSizes]="[5, 10, 25, 50]"
        [showPageSizeSelector]="true"
        [showBorders]="true"
      >
      </app-data-grid>
    </div>
  </div>
</div>
